import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateLifecycle } from '../../../../state';
import { shouldCommitDateInputChange } from '../../../../../../utils/DateConversions';

const StartDateEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentRecurringTask } = useAppSelector(state => state.recurringTask);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const raw = event.target.value;
    if (!shouldCommitDateInputChange(raw, currentRecurringTask?.startDate)) return;
    dispatch(updateLifecycle({ startDate: raw }));
  };

  return (
    <TextField
      label="Start Date"
      value={currentRecurringTask?.startDate || ''}
      onChange={handleChange}
      size="small"
      type="date"
      required
      InputLabelProps={{ shrink: true }}
      sx={{ minWidth: 180 }}
      helperText="First date tickets will be generated"
    />
  );
};

export default StartDateEdit;
